<script setup>
import { Link, useForm, router } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import Pagination from '@/Components/Pagination.vue';
import { ref, watch, onMounted } from "vue";
import debounce from "lodash/debounce";
import { useToast } from 'vue-toast-notification';
import Loading from 'vue-loading-overlay';
import { Modal } from 'bootstrap';

const props = defineProps({
    year: String,
    roomCategories: Object,
    filters: Object,
    flash: Object,
    roomcategory: Object,
    user: Object,
});

const $toast = useToast();
let isLoading = ref(false);
let modalShow = ref(null);
let thisModalObj = null;
let categorySearch = ref(props.filters.categorySearch ?? '');

watch(categorySearch, debounce(function (value) {
    router.get('/roomcategories', { categorySearch: value }, {
        preserveState: true,
        replace: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
    });
}, 700));

onMounted(() => {
    thisModalObj = new Modal(modalShow.value);
});

const CategoryAddform = useForm({
    name: null,
});

const RoomCategoryAddformSubmit = () => {
    CategoryAddform.post('/roomcategories/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide(),
                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                });
        }
    });
};

function getRoomCategoryData(value) {
    axios.get("/roomcategories/edit/", {
        params: {
            categoryid: value
        }
    }).then((response) => {
        if (response.data) {
            RoomCategoryEditform.name = response.data.name;
            RoomCategoryEditform.category_id = response.data.id;
        }
    });
}

const RoomCategoryEditform = useForm({
    name: null,
    category_id: null,
});

const RoomCategoryEditformSubmit = () => {
    RoomCategoryEditform.post('/roomcategories/update', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide(),
                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                });
        }
    });
};

const getInitials = (name) => {
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
    let initials = [...name.matchAll(rgx)] || [];
    initials = (
        (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
    ).toUpperCase();
    return initials;
};

function FormReset() {
    CategoryAddform.reset();
    CategoryAddform.clearErrors();
    thisModalObj.hide();
}
</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import "vue-loading-overlay/dist/vue-loading.css";
</style>
<template>
    <AppLayout title="Room Categories" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <div class="card">
                <div class="card-datatable table-responsive">
                    <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div class="card-header flex-column flex-md-row">
                            <div class="head-label text-center">
                                <h5 class="card-title mb-0">Room Category Manager</h5>
                            </div>
                            <div class="dt-action-buttons text-end pt-3 pt-md-0">
                                <div class="dt-buttons">
                                    <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                        v-if="$page.props.user.permissions.includes('add-room-category')"
                                        data-bs-target="#addRoomCategoryModal">
                                        <i class='bx bx-plus bx-tada'></i> Add New Category
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-12 d-flex justify-content-center justify-content-md-end">
                                <div class="dataTables_filter">
                                    <label>Search:
                                        <input v-model="categorySearch" type="text" class="form-control"
                                            placeholder="Type category name"></label>
                                </div>
                            </div>
                        </div>
                        <table class="datatables-basic table border-top dataTable no-footer dtr-column"
                            id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info"
                            style="width: 1390px;">
                            <thead>
                                <tr role="row">
                                    <th>Category Name</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="odd" v-for="(categories, index) in roomCategories.data" :key="categories.id">
                                    <td>
                                        <div class="d-flex justify-content-start align-items-center user-name">
                                            <div class="avatar-wrapper">
                                                <div class="avatar me-2"><span
                                                        class="avatar-initial rounded-circle bg-label-warning">{{
                                                            getInitials(categories.name)
                                                        }}</span>
                                                </div>
                                            </div>
                                            <div class=" d-flex flex-column"><span class="emp_name text-truncate">{{
                                                categories.name
                                            }}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <Link v-if="$page.props.user.permissions.includes('edit-room-category')"
                                            data-bs-toggle="modal" data-bs-target="#editRoomCategoryModal" href="#"
                                            @click="getRoomCategoryData(categories.id)"
                                            class="btn btn-icon btn-label-secondary" preserve-scroll replace>
                                        <i class="tf-icons bx bx-edit"></i>
                                        </Link>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div class="dataTables_info" id="DataTables_Table_0_info" role="status"
                                    aria-live="polite">Showing {{ roomCategories.from }} to {{ roomCategories.to }} of
                                    {{
                                        roomCategories.total
                                    }} hotels</div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="dataTables_paginate">
                                    <Pagination :links="roomCategories.links"></Pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="addRoomCategoryModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add Room Category</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="RoomCategoryAddformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col mb-3">
                                    <label for="nameBasic" class="form-label">Category Name</label>
                                    <input type="text" v-model="CategoryAddform.name" class="form-control"
                                        placeholder="Room category name" required="required">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" href="#" class="btn btn-label-secondary" @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Add</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal fade" id="editRoomCategoryModal" tabindex="-1" aria-modal="true" role="dialog"
            ref="modalShow">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit Room Category</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="RoomCategoryEditformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col mb-3">
                                    <label for="name" class="form-label">Category Name</label>
                                    <input name="name" placeholder="Room category name" class="form-control" type="text"
                                        v-model="RoomCategoryEditform.name" required="required">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" @click="closeModal">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Save changes</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>